import {ErrorMessage, Field, getIn} from 'formik'
import {ToolTipUI} from '../UI/ToolTipUI'
import clsx from 'clsx'
import {ToolTipUIForModal} from '../UI/ToolTipUIForModal'

export const InputWithSub = ({
  fieldName,
  type,
  label,
  toolTipText,
  placeholder,
  placeholderSelect,
  formik,
  options,
  margin,
  isFieldArray,
  isTooltipNotRequired,
  width,
  isStarRequired,
  isSearchIcon,
  disabled,
  isTooltipForModal,
  selectOptionFieldName,
  isCurrencyDropdown = false,
  isDropdownDisabled = false,
  defaultValue,
  onBlur,
}: {
  fieldName: string
  label?: string
  type?: string
  toolTipText?: string
  placeholder: string
  placeholderSelect: string
  formik: any
  options: Array<{name: string; id: number; value: string}> | string[]
  margin?: string
  isFieldArray?: boolean
  isTooltipNotRequired?: boolean
  width?: number
  isStarRequired?: boolean
  isSearchIcon?: boolean
  disabled?: boolean
  isTooltipForModal?: boolean
  selectOptionFieldName: string
  isCurrencyDropdown?: boolean
  isDropdownDisabled?: boolean
  defaultValue?: string | number | undefined
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
}) => {
  const FieldArrayErrorMessage = ({name}: any) => (
    <Field
      name={name}
      render={({form}: any) => {
        const error = getIn(form.errors, name)
        const touch = getIn(form.touched, name)
        return touch && error ? error : null
      }}
    />
  )

  // Determine if options is an array of objects or strings
  const renderOptions = () => {
    if (Array.isArray(options)) {
      if (typeof options[0] === 'string') {
        // Array of strings
        return (options as string[]).map((option, index) => (
          <option key={index} value={option}>
            {isCurrencyDropdown ? option?.split(' ')[0] : option}
          </option>
        ))
      } else {
        // Array of objects
        return (options as Array<{name: string; id: number; value: string}>).map(
          ({name, id, value}) => (
            <option key={id} value={value}>
              {isCurrencyDropdown ? name?.split(' ')[0] : name}
            </option>
          )
        )
      }
    }
    return null
  }

  const handleChange = async(e: React.ChangeEvent<HTMLInputElement>) => {
    if (fieldName === 'pricePerShare') {
      formik.setFieldValue(fieldName, e.target.value)
      
      if (formik.values.numberOfShares) {
        formik.setFieldValue(
          'totalTransactionValue',
          formik.values.numberOfShares * Number(e.target.value)
        )
        console.log(formik.values.numberOfShares * Number(e.target.value));
        
        formik.setFieldValue('totalAmountPaid', formik.values.numberOfShares * Number(e.target.value))
      }
    } else if (fieldName === 'purchasePerUnit' ) {     
      formik.setFieldValue(fieldName, e.target.value)
      if (formik.values.warrantIssued) {
        formik.setFieldValue('amountPaid', formik.values.warrantIssued * Number(e.target.value))
      }
      const errors =  await formik.validateForm()
      console.log(errors);
      if(errors["purchasePerUnit"]){
        formik.setFieldError('purchasePerUnit', undefined)
      }
      
    } else {
      formik.setFieldValue(fieldName, e.target.value)
    }
  }

  return (
    <div className={`fv-row mb-7 ${margin ? margin : ''} ${width ? `col-md-${width}` : ''}`}>
      {label && (
        <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
          {label}
          {!isTooltipNotRequired && (
            <>
              {!isStarRequired && '*'}
              {isTooltipForModal ? (
                <ToolTipUIForModal tooltipText={toolTipText} />
              ) : (
                <ToolTipUI tooltipText={toolTipText} />
              )}
            </>
          )}
        </label>
      )}

      <div className='d-flex align-items-center gap-2'>
        <Field
          as='select'
          name={selectOptionFieldName}
          disabled={isDropdownDisabled}
          className={clsx(
            `${isSearchIcon ? 'form-search-select' : ''} form-select h-40px font-size-13 w-25`,
            {
              'is-invalid-local':
                formik.touched[selectOptionFieldName] && formik.errors[selectOptionFieldName],
            },
            {
              'is-valid-local':
                formik.touched[selectOptionFieldName] && !formik.errors[selectOptionFieldName],
            }
          )}
        >
          <option className='text-muted' hidden>
            {placeholderSelect}
          </option>
          {renderOptions()}
        </Field>

        <input
          type={type ? type : 'text'}
          name={fieldName}
          placeholder={placeholder}
          disabled={disabled}
          value={formik.values[fieldName] ?? ''}
          onBlur={onBlur}
          onChange={handleChange}
          className={clsx(
            'form-control h-40px font-size-13 w-75',
            {'is-invalid-local': formik.touched[fieldName] && formik.errors[fieldName]},
            {'is-valid-local': formik.touched[fieldName] && !formik.errors[fieldName]}
          )}
        />
      </div>

      <div className='text-danger mt-2'>
        {isFieldArray ? (
          <FieldArrayErrorMessage name={selectOptionFieldName} />
        ) : (
          <ErrorMessage name={selectOptionFieldName} />
        )}
        {isFieldArray ? (
          <FieldArrayErrorMessage name={fieldName} />
        ) : (
          <ErrorMessage name={fieldName} />
        )}
      </div>
    </div>
  )
}
